import * as React from 'react'
import { Box } from '@mui/material'
import {formatPercentage} from "@ui-seeker/utils";


export default function buyboxWonColumn() {
	return {
		name: 'buyboxWon', label: '1P won Buy Box',
		options: {
			filter: false,
			customBodyRowRenderLite: (value, {isBuyboxNA}) => <Box sx={{ textAlign: 'center' }}>
                {isBuyboxNA ? 'N/A' : formatPercentage(value, { decimals: 2 })}
            </Box>
		}

	}
}